import { ThumbsUp } from "lucide-react";

// Agency logo for documents: uses the uploaded official logo if provided (src),
// otherwise falls back to a CSS recreation of the Hi Social wordmark.
export default function HiSocialLogo({ size = "md", src = null }) {
  const big = size === "lg";
  if (src) {
    return (
      <img
        src={src}
        alt="Logo agenzia"
        style={{ height: big ? 90 : 60, width: "auto", maxWidth: big ? 320 : 240, objectFit: "contain", display: "block" }}
      />
    );
  }
  return (
    <div className="flex flex-col">
      <div className="flex items-center" style={{ gap: big ? 6 : 4 }}>
        <span
          style={{ fontWeight: 800, fontSize: big ? 40 : 28, color: "#ec0f8e", lineHeight: 1 }}
        >
          Hi
        </span>
        <span
          className="inline-flex items-center justify-center rounded-md"
          style={{
            background: "linear-gradient(135deg,#ec0f8e,#a21caf)",
            width: big ? 34 : 24,
            height: big ? 34 : 24,
            marginLeft: 2,
            marginRight: 2,
          }}
        >
          <ThumbsUp size={big ? 20 : 14} color="#fff" fill="#fff" />
        </span>
        <span
          style={{
            fontWeight: 800,
            fontSize: big ? 40 : 28,
            lineHeight: 1,
            background: "linear-gradient(90deg,#ec0f8e,#a21caf)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
            color: "#a21caf",
          }}
        >
          Social
        </span>
      </div>
      <div
        style={{
          fontWeight: 700,
          fontSize: big ? 13 : 9,
          color: "#ec0f8e",
          letterSpacing: 0.5,
          marginTop: 2,
        }}
      >
        Social Media Strategies
      </div>
    </div>
  );
}
